import { Box, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";

const Projects = () => {
    const { t } = useTranslation();
    
    return (
        <Box ml={5} mt={5}>
            <Typography variant="h2">{t('projects.myProjects')}</Typography>
        </Box>
    );
};

export default Projects;